export default {
  status: {
    pending: 'Wartet auf DNS',
    verified: 'Live',
    failed: 'Handlungsbedarf',
  },
  summary: {
    preparing:
      'Die Einträge für {{host}} werden vorbereitet und erscheinen hier innerhalb von etwa 15 Minuten — oder sofort nach einem Klick auf „Erneut prüfen“.',
    pending:
      'Wir warten auf die DNS-Einträge unten. Das dauert meist ein paar Minuten und kann bis zu 48 Stunden dauern — wir prüfen selbstständig weiter.',
    certificate_pending:
      'Die Einträge sind vorhanden. Das Zertifikat für {{host}} wird ausgestellt — das dauert meist ein paar Minuten.',
    verified: 'Der Online-Shop ist live auf {{host}}.',
    serving: 'Der Online-Shop ist live auf {{serving_host}}, aber {{host}} selbst öffnet ihn noch nicht.',
    apex_elsewhere:
      'Der A-Eintrag auf @ zeigt noch nicht auf den Shop. Zeigt {{host}} eine Website, die dort bleiben soll, @ unverändert lassen — der Shop funktioniert unter {{serving_host}}. Andernfalls den A-Eintrag unten anlegen.',
    apex_held:
      '{{host}} wird von einer anderen Website auf Vercel verwendet. Damit auch {{host}} den Shop öffnet, die Domain zuerst von dieser Website entfernen.',
    regressed:
      '{{host}} hat bereits funktioniert, aber ein Eintrag unten wird nicht mehr bestätigt. Bitte beim DNS-Anbieter korrigieren und dann auf „Erneut prüfen“ klicken.',
    record_elsewhere:
      'Ein Eintrag unten zeigt auf ein anderes Ziel. Bitte beim DNS-Anbieter auf den angezeigten Wert ändern und dann auf „Erneut prüfen“ klicken.',
    records_missing:
      'Die Einträge unten werden auch nach 48 Stunden nicht gefunden. Bitte prüfen, ob sie für {{zone}} bei dem Anbieter gespeichert wurden, der dessen DNS verwaltet. Lässt dieser Anbieter die Änderung nicht zu, ist die Domain dort möglicherweise gesperrt.',
    certificate: {
      ownership_proof_required:
        '{{host}} ist auch mit einem anderen Vercel-Konto verbunden, daher muss nachgewiesen werden, dass die Domain dem Restaurant gehört.',
      held_by_another_project:
        '{{host}} wird noch von einer anderen Website auf Vercel verwendet, deshalb kann der Shop die Domain noch nicht nutzen.',
      dns_correct_but_unconfigured:
        'Die Einträge sind korrekt, aber etwas anderes auf {{host}} verhindert das Zertifikat.',
      name_mismatch: '{{host}} antwortet noch mit einem Zertifikat für einen anderen Namen.',
      expired: 'Das Zertifikat für {{host}} ist abgelaufen. Wir wurden benachrichtigt und kümmern uns darum.',
      expiring: 'Das Zertifikat für {{host}} läuft bald ab und wurde noch nicht erneuert. Wir kümmern uns darum.',
      attach_refused:
        'Unser Hosting-Anbieter hat {{host}} auf unserer Seite nicht hinzugefügt. Wir wurden benachrichtigt und kümmern uns darum.',
      overdue: 'Das Zertifikat für {{host}} wurde auch nach 48 Stunden noch nicht ausgestellt.',
      unknown: 'Das Zertifikat für {{host}} konnte nicht ausgestellt werden.',
    },
    certificate_see_row: 'In der Zeile „Zertifikat“ unten steht, was zu tun ist.',
  },
  instructions: {
    title: '{{host}} verbinden',
    step_provider:
      'Beim Anbieter anmelden, bei dem die DNS von {{zone}} verwaltet wird — meist das Unternehmen, bei dem die Domain gekauft wurde.',
    step_add: 'Jeden Eintrag unten genau so anlegen wie angezeigt: Typ, Name und Wert.',
    step_check: 'Speichern und dann auf „{{button}}“ klicken. Wir prüfen außerdem selbstständig weiter.',
    tip_name:
      'Die meisten Anbieter erwarten im Namensfeld nur den Teil vor {{zone}} — hier {{names}}. Der vollständige Name steht ebenfalls da, für Anbieter, die ihn verlangen.',
    tip_apex: '@ steht für {{zone}} selbst. Manche Anbieter lassen das Namensfeld dafür stattdessen leer.',
    tip_apex_website:
      'Öffnet {{zone}} bereits eine Website, wird {{zone}} mit dem Eintrag auf @ von dieser Website auf den Shop umgestellt. Soll die Website dort bleiben, die Einträge auf @ unverändert lassen — der Shop funktioniert weiterhin unter www.{{zone}} — oder stattdessen eine Subdomain wie order.{{zone}} für den Shop verbinden.',
    tip_existing:
      'Andere A-, AAAA- oder CNAME-Einträge für {{name}} entfernen. Zwei Einträge, die auf verschiedene Ziele zeigen, lassen den Shop nur manchmal laden.',
    tip_cloudflare:
      'Bei Cloudflare diese Einträge auf „Nur DNS“ stellen (graue Wolke). Mit aktivem Proxy ist nicht sichtbar, wohin sie zeigen, und es kann kein Zertifikat ausgestellt werden.',
    tip_locked:
      'Lässt der Anbieter das Anlegen oder Ändern dieser Einträge nicht zu, ist die Domain möglicherweise gesperrt oder ihre DNS wird an anderer Stelle verwaltet. Der Anbieter kann sie entsperren oder sagen, wo die DNS verwaltet wird.',
  },
  records: {
    title: 'Einträge für {{host}}',
  },
  separate_domains: {
    apex: 'Diese Domain ist nur für den Online-Shop: Der Shop belegt {{zone}} und www.{{zone}}. Eine Website braucht einen anderen Namen — eine Subdomain von {{zone}} oder eine eigene Domain.',
    subdomain: 'Diese Domain ist nur für den Online-Shop. Eine Website kann {{zone}} oder www.{{zone}} verwenden.',
  },
  load_error: 'Der Domain-Status konnte nicht geladen werden.',
  no_access: 'Kein Zugriff auf den Domain-Status dieses Restaurants.',
  polling_stopped:
    'Diese Seite aktualisiert sich nicht mehr selbstständig. Ein Klick auf „Erneut prüfen“ aktualisiert sie.',
  buttons: {
    check_again: 'Erneut prüfen',
    retry: 'Erneut versuchen',
  },
  toasts: {
    check_started: 'Die Einträge werden geprüft. Das kann eine Minute dauern.',
    check_failed: 'Die Prüfung konnte nicht gestartet werden. Bitte erneut versuchen.',
    check_too_soon: 'Gerade eben geprüft. Bitte eine Minute warten, bevor erneut geprüft wird.',
  },
};
